// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-container {
  padding: 10px 20px;
}
Details.css .status-container {
  display: flex;
  flex-direction: column;
}

.titleLineHeight {
  line-height: 100;
}
/* .ant-steps-vertical .ant-steps-item {
    background-color: white;
    margin-bottom: 10px;
  } */
/* SolutionFilesAccordion.css */
.solution-tabs .ant-tabs-ink-bar {
  display: none !important;
}

.solution-tabs
  :where(.css-dev-only-do-not-override-1m16aby).ant-tabs-top
  > .ant-tabs-nav::before,
:where(.css-dev-only-do-not-override-1m16aby).ant-tabs-bottom
  > .ant-tabs-nav::before,
:where(.css-dev-only-do-not-override-1m16aby).ant-tabs-top
  > div
  > .ant-tabs-nav::before,
:where(.css-dev-only-do-not-override-1m16aby).ant-tabs-bottom
  > div
  > .ant-tabs-nav::before {
  border-bottom: none !important;
}
.ant-steps-item-title {
  color: black;
}

.ant-popover-inner-content {
  padding: 0;
}

.scrollable-container {
  overflow-x: auto; /* Enables horizontal scrolling */
  white-space: nowrap; /* Prevents wrapping */
  width: 100%; /* Full width */
  padding-bottom: 5px; /* Prevents content from overlapping scrollbar */
  scrollbar-width: none; /* Hides scrollbar in Firefox */
  -ms-overflow-style: none; /* Hides scrollbar in IE/Edge */
}

.scrollable-container::-webkit-scrollbar {
  display: none; /* Hides scrollbar in Chrome, Safari */
}

.fixed-container {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
  min-width: max-content; /* Ensures content doesn't shrink */
}

.flex-1 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.flex-2 {
  display: flex;
  gap: 1rem;
}
.table-container {
  overflow-x: auto; /* Allows horizontal scrolling */
}

.field-label {
  font-weight: bold;
}

.editable-value {
  cursor: pointer;
  color: #1890ff;
}

.popover-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.fixedDetaisls2 {
  display: flex;
  padding: 20px;
  align-items: center;
}

.feedback-card .ant-card-head {
  background-color: var(--feedback-bg, #ffffff); /* Fallback to white */
}

/* Feedback details content - ensure text wraps properly */
.feedback-details-content {
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

.feedback-details-content p {
  margin: 0 0 10px 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

.feedback-details-content pre,
.feedback-details-content pre.ql-syntax {
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
}
:where(.css-dev-only-do-not-override-1m16aby).ant-layout,
:where(.css-dev-only-do-not-override-1m16aby).ant-layout {
  border: none !important;
}
/* Responsive design for better view on smaller screens */
@media (max-width: 768px) {
  .details-table {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/page-components/OrderDetail/Details.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;AACA;;;KAGK;AACL,+BAA+B;AAC/B;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;EAWE,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB,EAAE,iCAAiC;EACnD,mBAAmB,EAAE,sBAAsB;EAC3C,WAAW,EAAE,eAAe;EAC5B,mBAAmB,EAAE,gDAAgD;EACrE,qBAAqB,EAAE,+BAA+B;EACtD,wBAAwB,EAAE,+BAA+B;AAC3D;;AAEA;EACE,aAAa,EAAE,sCAAsC;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB,EAAE,mCAAmC;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6CAA6C,EAAE,sBAAsB;AACvE;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,iCAAiC;AACnC;AACA;;EAEE,uBAAuB;AACzB;AACA,yDAAyD;AACzD;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".details-container {\n  padding: 10px 20px;\n}\nDetails.css .status-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.titleLineHeight {\n  line-height: 100;\n}\n/* .ant-steps-vertical .ant-steps-item {\n    background-color: white;\n    margin-bottom: 10px;\n  } */\n/* SolutionFilesAccordion.css */\n.solution-tabs .ant-tabs-ink-bar {\n  display: none !important;\n}\n\n.solution-tabs\n  :where(.css-dev-only-do-not-override-1m16aby).ant-tabs-top\n  > .ant-tabs-nav::before,\n:where(.css-dev-only-do-not-override-1m16aby).ant-tabs-bottom\n  > .ant-tabs-nav::before,\n:where(.css-dev-only-do-not-override-1m16aby).ant-tabs-top\n  > div\n  > .ant-tabs-nav::before,\n:where(.css-dev-only-do-not-override-1m16aby).ant-tabs-bottom\n  > div\n  > .ant-tabs-nav::before {\n  border-bottom: none !important;\n}\n.ant-steps-item-title {\n  color: black;\n}\n\n.ant-popover-inner-content {\n  padding: 0;\n}\n\n.scrollable-container {\n  overflow-x: auto; /* Enables horizontal scrolling */\n  white-space: nowrap; /* Prevents wrapping */\n  width: 100%; /* Full width */\n  padding-bottom: 5px; /* Prevents content from overlapping scrollbar */\n  scrollbar-width: none; /* Hides scrollbar in Firefox */\n  -ms-overflow-style: none; /* Hides scrollbar in IE/Edge */\n}\n\n.scrollable-container::-webkit-scrollbar {\n  display: none; /* Hides scrollbar in Chrome, Safari */\n}\n\n.fixed-container {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 8px;\n  min-width: max-content; /* Ensures content doesn't shrink */\n}\n\n.flex-1 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.flex-2 {\n  display: flex;\n  gap: 1rem;\n}\n.table-container {\n  overflow-x: auto; /* Allows horizontal scrolling */\n}\n\n.field-label {\n  font-weight: bold;\n}\n\n.editable-value {\n  cursor: pointer;\n  color: #1890ff;\n}\n\n.popover-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.fixedDetaisls2 {\n  display: flex;\n  padding: 20px;\n  align-items: center;\n}\n\n.feedback-card .ant-card-head {\n  background-color: var(--feedback-bg, #ffffff); /* Fallback to white */\n}\n\n/* Feedback details content - ensure text wraps properly */\n.feedback-details-content {\n  width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.feedback-details-content p {\n  margin: 0 0 10px 0;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.feedback-details-content pre,\n.feedback-details-content pre.ql-syntax {\n  white-space: pre-wrap !important;\n  word-wrap: break-word !important;\n  overflow-wrap: break-word !important;\n  word-break: break-word !important;\n}\n:where(.css-dev-only-do-not-override-1m16aby).ant-layout,\n:where(.css-dev-only-do-not-override-1m16aby).ant-layout {\n  border: none !important;\n}\n/* Responsive design for better view on smaller screens */\n@media (max-width: 768px) {\n  .details-table {\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
